import { render, staticRenderFns } from "./passChange.vue?vue&type=template&id=02e20453&scoped=true&"
var script = {}
import style0 from "./passChange.vue?vue&type=style&index=0&id=02e20453&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e20453",
  null
  
)

export default component.exports